import React from 'react';

function FuelAndCashCard({ form, handleChange }) {
  return (
    <div className="card mb-4 border-left-warning shadow-sm">
      <div className="card-body">
        <h5 className="card-title text-warning mb-3">Fuel & Cash</h5>
        <div className="row g-3">
          <div className="col-md-3">
            <label className="form-label">Qty (MT)</label>
            <input
              type="text"
              name="qty"
              className="form-control"
              inputMode="decimal"
              pattern="^\d+(\.\d{0,3})?$"
              value={form.qty}
              onChange={handleChange}
              placeholder="e.g. 5.123"
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">Diesel Issued (Ltrs)</label>
            <input
              type="number"
              name="diesel_ltr"
              className="form-control"
              value={form.diesel_ltr}
              onChange={handleChange}
              step="0.01"
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">Cash Given (₹)</label>
            <input
              type="number"
              name="cash_amount"
              className="form-control"
              value={form.cash_amount}
              onChange={handleChange}
              step="0.01"
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">Remark</label>
            <input
              type="text"
              name="remark"
              className="form-control"
              value={form.remark}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default FuelAndCashCard;
